const url = "/api/v1/";

class CustomReportService {
  
  // Get custom report
  async getCustomReportService(payload, signal) {
    
    const new_url = url + "cpu/report/reportBuilder";

    //console.log('Fetching custom report with payload:', payload);
    //console.log('url', new_url)
  
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(new_url, {
          method: "POST",
          headers: { 
            'Firebase-UID': '123456789', 
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload),
        });

        let json = await response.json();

        if (response.status >= 400 && response.status < 600) {
          throw new Error('Error getting custom report');
        }

        // append payload to response for reference
        json.request = payload;
        resolve(json);
        
      } catch (e) {

        console.log('error', e)
        
        if (e.name === 'AbortError') {
          reject(new Error('Request was cancelled'));
        } else {
          reject(new Error(e));
        }
      }
    });
  }

  // Save custom report
  async saveCustomReportService(payload) {
    
    const new_url = url + "cpu/report/customReports";

    //console.log('Saving custom report with payload:', payload);
    console.log('url', new_url)
  
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(new_url, {
          method: "POST",
          headers: { 
            'Firebase-UID': '123456789', 
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload),
        });

        let json = await response.json();

        if (response.status >= 400 && response.status < 600) {
          throw new Error('Error saving custom report');
        }

        resolve(json);
        
      } catch (e) {

        console.log('error', e)
        
        if (e.name === 'AbortError') {
          reject(new Error('Request was cancelled'));
        } else {
          reject(new Error(e));
        }
      }
    });
  }

  // delete custom report
  async deleteCustomReportService(reportId) {
    const new_url = url + "cpu/report/customReports/" + reportId;

    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(new_url, {
          method: "DELETE",
          headers: {
            'Firebase-UID': '123456789',
            'Content-Type': 'application/json'
          }
        });

        if (response.status >= 400 && response.status < 600) {
          throw new Error('Error deleting custom report');
        }

        resolve(await response.json());
      } catch (e) {
        console.log('error', e);
        if (e.name === 'AbortError') {
          reject(new Error('Request was cancelled'));
        } else {
          reject(new Error(e));
        }
      }
    });
  }

  // get report list
  async getReportListService(iata) {
    
    const new_url = url + "cpu/report/customReports?iata=" + iata;

    //console.log('Fetching report list with payload:',
    //console.log('url', new_url)

    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(new_url, {
          method: "GET",
          headers: { 
            'Firebase-UID': '123456789', 
            'Content-Type': 'application/json'
          }
        });

        let json = await response.json();

        if (response.status >= 400 && response.status < 600) {
          throw new Error('Error getting report list');
        }

        resolve(json);
        
      } catch (e) {

        //console.log('error', e)
        
        if (e.name === 'AbortError') {
          reject(new Error('Request was cancelled'));
        } else {
          reject(new Error(e));
        }
      }
    });
  }
}

export default new CustomReportService();
